<script setup>
import { router } from '@inertiajs/vue3';
import moment from 'moment';
import { ref } from 'vue';
import JetButton from '@/Jetstream/Button.vue';
import JetSecondaryButton from '@/Jetstream/SecondaryButton.vue';
import JetDialogModal from '@/Jetstream/DialogModal.vue';
import { BIconXCircleFill, BIconFileWord, BIconFilePdf, BIconFileExcel,  BIconFileEarmarkSlides, BIconFileEarmarkArrowUp, BIconImage} from 'bootstrap-icons-vue';

const programme = router.page.props.ziggy.programme;
const organisation = router.page.props.ziggy.organisation;
const urlNamePrefix = organisation ? "gi." : "";

const deleteConfirm = ref(false);

const props = defineProps({
    evidence: Object,
    loggedInUserId: Number,
    filters: Object,
    pastToolkit: Boolean,
    toolkit_id: Number,
    editable: Boolean
});


const bytesToSize = (bytes) => {
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  if (bytes === 0) return 'n/a';
  const i = parseInt(Math.floor(Math.log(Math.abs(bytes)) / Math.log(1024)), 10);
  if (i === 0) return `${bytes} ${sizes[i]}`;
  return `${(bytes / (1024 ** i)).toFixed(1)} ${sizes[i]}`;
}

const created_at = moment(String(props.evidence.created_at)).format('MM/DD/YYYY hh:mm')

const deleteEvidence = () => {

    router.post(route(urlNamePrefix+'action-evidence.destroy'),
        {
            id: props.evidence.id,
            filters: props.filters,
            pastToolkit: props.pastToolkit,
            toolkit_id: props.toolkit_id
        },
        {
            preserveState: true,
            preserveScroll: true
        });
        deleteConfirm.value = false;
}

const deleteModal = () => {
    deleteConfirm.value = true;
};

const closeModal = () => {
    deleteConfirm.value = false;
};

const getFilepath = (file) => {
    return '/storage/'+ file;
}

const getCreatedAt = (date) => {
    return moment(date).format('MM/DD/YYYY hh:mm');
}

</script>

<template>

    <div class="flex py-2">
        <div class="flex flex-row mr-3">
            <BIconXCircleFill v-if="evidence.user_id == loggedInUserId && editable" class="delete-evidence relative left-5 top-0 h-15 w-15 text-xl border-2 border-white rounded-lg" style="color:red;cursor: pointer;" v-on:click="deleteModal();"/>
            <BIconFileWord v-if="evidence.file_type == 'docx'" class="relative left-3 top-0 h-16 w-16 text-xl" />
            <BIconFilePdf v-if="evidence.file_type == 'pdf'" class="relative left-3 top-0 h-16 w-16 text-xl" />
            <BIconFileExcel v-if="evidence.file_type == 'xls'" class="relative left-3 top-0 h-16 w-16 text-xl" />
            <BIconFileExcel v-if="evidence.file_type == 'xlsx'" class="relative left-3 top-0 h-16 w-16 text-xl" />
            <BIconFileExcel v-if="evidence.file_type == 'xltx'" class="relative left-3 top-0 h-16 w-16 text-xl" />
            <BIconFileEarmarkSlides v-if="evidence.file_type == 'ppt'" class="relative left-3 top-0 h-16 w-16 text-xl" />
            <!-- <BIconFileEarmarkArrowUp v-else class="relative left-3 top-0 h-16 w-16 text-xl" /> -->
        </div>
        <div class="flex flex-col pt-1">
            <div class="flex flex-col flex-wrap">
                <a target="_blank" class="hover:underline" :href=getFilepath(evidence.file_path)>{{evidence.file_name}} ({{ bytesToSize(evidence.file_size) }})</a>
            </div>
            <div class="flex flex-col text-xs text-gray-500">
                {{ $t('toolkit.evidence.uploaded_by') }} {{evidence.first_name}} {{evidence.last_name}} - {{getCreatedAt(String(evidence.created_at))}}
            </div>
        </div>
    </div>

    <JetDialogModal :show="deleteConfirm" @close="closeModal">
            <template #title>
                <span class="text-lg font-bold">{{ $t('toolkit.evidence.delete_confirm_title') }}</span>
            </template>

            <template #content>
                {{ $t('toolkit.evidence.delete_warning') }}
            </template>

            <template #footer>
                <JetSecondaryButton @click="closeModal">
                    {{ $t('toolkit.evidence.delete_cancel') }}
                </JetSecondaryButton>

                <JetButton
                    class="ml-3"
                    @click="deleteEvidence"
                >
                {{ $t('toolkit.evidence.delete_confirm') }}
                </JetButton>
            </template>
        </JetDialogModal>

</template>
